import { render } from "./PeppolDocuments.vue?vue&type=template&id=4f6c1cc7&scoped=true"
import script from "./PeppolDocuments.vue?vue&type=script&lang=js"
export * from "./PeppolDocuments.vue?vue&type=script&lang=js"

import "./PeppolDocuments.vue?vue&type=style&index=0&id=4f6c1cc7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6c1cc7"]])

export default __exports__